module.exports = __webpack_public_path__ + "media/images/sales/nanairoweek/price-opening-3e2335611239d5da140cd5a122414e24.svg";